var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
export class Menu extends Component {
    constructor() {
        super('Menu', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            // Menu opening
            $('.btn-toggle-menu').on('click', (event, button) => {
                event.preventDefault();
                button.toggleClass('is-active');
                this.toggleMenu();
            });
            $('.is-forced a:not(.btn-close)').on('click', (event, button) => {
                event.preventDefault();
                this.openMenu();
                /*$('.is-forced a').removeClass('is-active current-menu-item');
                button.addClass('is-active');*/
            });
            // Menu closing
            $('#menu-mask, menu .btn-close').on('click', (event) => {
                event.preventDefault();
                $('.language-switcher').removeClass('d-none');
                Menu.closeMenu();
            });
            // Menu navigation
            $('menu a:not(.btn-close):not(.wpml-ls-item)').on('click', (event, button) => {
                event.preventDefault();
                const tabWasActive = button.hasClass('is-active');
                $('menu a').removeClass('is-active current-menu-item');
                if (tabWasActive) {
                    Menu.closeMenu();
                    return;
                }
                button.addClass('is-active');
                $('.tab').addClass('d-none');
                $(`.tab[data-id="${button.attr('href').replace('#', '')}"]`).removeClass('d-none');
                if (button.attr('href') === '#contact')
                    $('.language-switcher').addClass('d-none');
            });
            // Miscellanous
            $(window).on('resize', () => {
                this.updateMenuHeight();
                this.updatePagePaddingTop();
            });
            this.updateMenuHeight();
            this.updatePagePaddingTop();
            // End of initialization
            this.success();
        });
    }
    toggleMenu() {
        if ($('menu').hasClass('is-open')) {
            Menu.closeMenu();
        }
        else {
            this.openMenu();
        }
    }
    openMenu() {
        $('menu').addClass('is-active');
        $('.tab').addClass('d-none').first().removeClass('d-none');
        $('menu, aside, #menu-mask').addClass('is-open');
        $('.header-default').removeClass('justify-content-between').addClass('justify-content-end');
        $('.header-default .btn-info').addClass('d-none');
        $('.icon-menu').removeClass('bg-light').addClass('bg-white');
        if ($(window).width() < 991)
            $('menu a').first().addClass('is-active');
        this.disablePageScroll();
    }
    static closeMenu(ignoreScroll = false) {
        $('menu').removeClass('is-active');
        $('.btn-toggle-menu, menu a').removeClass('is-active current-menu-item');
        $('menu, aside, #menu-mask').removeClass('is-open');
        if ($('#project-content').length > 0) {
            $('.header-default').addClass('justify-content-between').removeClass('justify-content-end');
            $('.header-default .btn-info').removeClass('d-none');
        }
        $('.icon-menu').removeClass('bg-white').addClass('bg-light');
        if (!ignoreScroll)
            Menu.enablePageScroll();
    }
    updatePagePaddingTop() {
        $('body').css('--page-padding-top', $('menu').height() + 'px');
    }
    static enablePageScroll() {
        $('body').removeClass('has-no-scroll');
        document.documentElement.scrollTop = parseFloat($('body').css('--scroll-top')) * -1;
    }
    disablePageScroll() {
        $('body').css('--scroll-top', `${document.documentElement.scrollTop * -1}px`).addClass('has-no-scroll');
    }
    updateMenuHeight() {
        $('menu').css('--menu-height', $('menu').height() + 'px');
    }
}
